var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 62.5,
    fill: "#F3F4F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 70.4536C30 69.7522 30.5686 69.1836 31.27 69.1836H45.7213C46.4227 69.1836 46.9913 69.7522 46.9913 70.4536V98.4243H30V70.4536Z",
    fill: "url(#paint0_linear_9065_97868)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.733 42.3982C51.733 41.6968 52.3016 41.1282 53.003 41.1282H67.4542C68.1556 41.1282 68.7242 41.6968 68.7242 42.3982V98.4243H51.733V42.3982Z",
    fill: "url(#paint1_linear_9065_97868)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0466 23.4314C75.0466 22.73 75.6152 22.1614 76.3166 22.1614L90.7678 22.1614C91.4692 22.1614 92.0378 22.73 92.0378 23.4314V98.4243H75.0466V23.4314Z",
    fill: "url(#paint2_linear_9065_97868)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9065_97868",
    x1: 55,
    y1: 25,
    x2: 55.5,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93A0B7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901493,
    stopColor: "#8998B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9065_97868",
    x1: 55,
    y1: 25,
    x2: 55.5,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93A0B7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901493,
    stopColor: "#8998B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9065_97868",
    x1: 55,
    y1: 25,
    x2: 55.5,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93A0B7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901493,
    stopColor: "#8998B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.2805cd593ce88b941c7000d474507959.svg";
export { ForwardRef as ReactComponent };